import React, {Component} from 'react';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';

import * as KPIPlanningAction from "../../actions/KPIPlanningAction";
import Destinations from "../kpiPlanning/Destinations"


class DestinationModal extends Component {

    render() {
        const {modal, toggleModal} = this.props;

        return (
            <Modal isOpen={modal} size="lg" toggle={toggleModal}>
                <ModalHeader toggle={toggleModal}>
                    Destinations
                </ModalHeader>
                <ModalBody className="bg-white">
                    <div className="row">
                        <div className="col-12">
                            <Destinations {...this.props} />
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button className='btn btn-secondary' onClick={toggleModal}>Close</Button>
                </ModalFooter>
            </Modal>
        );
    }
}

function mapStateToProps(state) {
    return {
        agencyLocation: state.AgencyLocationReducer,
        kpiPlanning: state.KPIPlanningReducer,
    };
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, KPIPlanningAction), dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(DestinationModal);



// WEBPACK FOOTER //
// ./src/components/staffDashboardNav/DestinationsModal.js